/* eslint-disable no-restricted-syntax */
import { Button } from "@bleu.builders/ui";
import { RowsIcon } from "@radix-ui/react-icons";
import React from "react";

export const thesisGoupingOptions = [
  {
    label: "Tributo",
    value: "tax",
  },
  {
    label: "Categoria",
    value: "category",
  },
  {
    label: "Decisões Favoráveis",
    value: "decision",
  },
];

export function ThesesGroupOptions({ tableState, setTableState }) {
  return (
    <div className="flex gap-2 border rounded-lg items-center">
      <RowsIcon className="ml-2 size-4" />
      {thesisGoupingOptions.map((group) => (
        <Button
          key={group.value}
          variant={
            tableState.grouping.includes(group.value) ? "default" : "ghost"
          }
          size="sm"
          className="h-6 my-1 opacity-90"
          onClick={() => {
            setTableState.setGrouping([group.value]);
            setTableState.setSorting([
              { id: group.value, desc: false },
              { id: "title", desc: false },
            ]);
          }}
        >
          Agrupar por {group.label}
        </Button>
      ))}
    </div>
  );
}
